import { Font } from '@react-pdf/renderer';

let robotoRegistered = null;

/**
 * Roboto TTF'yi fetch edip ArrayBuffer ile kaydeder; böylece font render öncesi yüklü olur
 * ve Unicode (Türkçe) Identity-H ile doğru gömülür.
 * @returns {Promise<boolean>} Font başarıyla kaydedildiyse true
 */
export async function ensureRobotoFontForPdf() {
  if (robotoRegistered !== null) return robotoRegistered;
  try {
    const base = typeof window !== 'undefined' ? window.location.origin : '';
    const prefix = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    const fontUrl = `${base}${prefix}/fonts/Roboto-Regular.ttf`;
    Font.register({
      family: 'Roboto',
      src: fontUrl,
      fontStyle: 'normal',
      fontWeight: 400,
    });
    robotoRegistered = true;
    return true;
  } catch (e) {
    console.warn('Roboto font PDF için yüklenemedi, varsayılan font kullanılacak:', e);
    robotoRegistered = false;
    return false;
  }
}
